import { authRoles } from 'app/auth';
import i18next from 'i18next';

import OpcDaWriterLogEditForm from './editform/OpcDaWriterLogEditForm';
import OpcDaWriterLogTable from './table/OpcDaWriterLogTable';

import en from './i18n/en';
import hu from './i18n/hu';

i18next.addResourceBundle('en', 'opcDaWriterLog', en);
i18next.addResourceBundle('hu', 'opcDaWriterLog', hu);

export default [
	{
		path: '/opc-da-writer-log/edit/:id/:tabKey?',
		component: OpcDaWriterLogEditForm,
		auth: authRoles.opcDaWriterLog
	},
	{
		path: '/opc-da-writer-log/:sessionNameParam?',
		component: OpcDaWriterLogTable,
		auth: authRoles.opcDaWriterLog
	}
];